<!--suppress ALL -->

<template>
	<tr>
		<td class="text-xs-center">
			{{ city.name }}
		</td>
		<!--    <td class="text-xs-center">{{ city.projects_count }}</td>-->
		<td>
			<edit-btn @click="onEdit"/>
			<remove-btn/>
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/City.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "city-row",
		props: {
			city: {required: true}
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "city")],
		data() {
			return {};
		},
		computed: {},
		methods: {
			doRemove() {
				this.$store.dispatch(types.REMOVE, this.city).then(() => {
				});
			},
			onEdit() {
				this.$emit("edit", this.city);
			}
		}
	};
</script>

<style>


</style>
